import { render, staticRenderFns } from "./panel-block.vue?vue&type=template&id=1e7aa768"
import script from "./panel-block.vue?vue&type=script&lang=js"
export * from "./panel-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports